var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRise40(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1425_8454)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1425_8454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1425_8454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.9981 19.998C36.9981 29.386 29.3872 36.9961 20.0001 36.9961C10.613 36.9961 3 29.384 3 19.998C3 10.6121 10.613 3 20.0001 3C29.3872 3 36.9981 10.61 36.9981 19.998Z",
    fill: "#8FCFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9979 20C34.9979 28.285 28.2829 35 19.9979 35C11.7129 35 5 28.285 5 20C5 11.715 11.7129 5 20 5C28.2871 5 35 11.7171 35 20H34.9979Z",
    fill: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.352 8.84313C20.7376 8.84543 21.0603 8.54156 21.0603 8.16864V7.39977C21.0603 7.02685 20.7376 6.72069 20.352 6.71838H19.6348C19.2583 6.71838 18.9355 7.02685 18.9355 7.39977V8.16864C18.9355 8.54156 19.2583 8.84543 19.6348 8.84313H20.352Z",
    fill: "#5EBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.84302 19.9936V19.644C8.84302 19.2585 8.53849 18.9357 8.16706 18.9357H7.39422C7.02279 18.9357 6.71826 19.2495 6.71826 19.644V20.3522C6.71826 20.7377 7.02279 21.0605 7.39422 21.0605H8.16706C8.53849 21.0605 8.84302 20.7467 8.84302 20.3522V20.0026V19.9936Z",
    fill: "#5EBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1528 20.0026V20.3522C31.1528 20.7377 31.4547 21.0605 31.8281 21.0605H32.6001C32.9711 21.0605 33.2776 20.7467 33.2776 20.3522V19.644C33.2776 19.2585 32.9711 18.9357 32.6001 18.9357H31.8281C31.4547 18.9357 31.1528 19.2495 31.1528 19.644V19.9936V20.0026Z",
    fill: "#5EBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.352 32.7466C20.7376 32.7443 21.0603 32.4382 21.0603 32.0676V31.2941C21.0603 30.9212 20.7376 30.6196 20.352 30.6219H19.6348C19.2583 30.6219 18.9355 30.9212 18.9355 31.2941V32.0676C18.9355 32.4382 19.2583 32.7443 19.6348 32.7466H20.352Z",
    fill: "#5EBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9979 20.7636C19.4118 20.7636 18.9355 20.4213 18.9355 19.9981V10.8288C18.9355 10.4076 19.4118 10.0634 19.9979 10.0634C20.5841 10.0634 21.0603 10.4076 21.0603 10.8288V19.9981C21.0603 20.4213 20.5841 20.7636 19.9979 20.7636Z",
    fill: "#00D8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3593 21.0603H20.0749C19.7403 21.0603 19.4668 20.5847 19.4668 19.9965C19.4668 19.4083 19.7403 18.9355 20.0749 18.9355H27.3593C27.6955 18.9355 27.9658 19.4112 27.9658 19.9965C27.9658 20.5819 27.6955 21.0603 27.3593 21.0603Z",
    fill: "#00D8AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4623 19.9981C21.4623 20.806 20.8061 21.4601 20.0001 21.4601C19.194 21.4601 18.5378 20.806 18.5378 19.9981C18.5378 19.1901 19.192 18.538 20.0001 18.538C20.8082 18.538 21.4623 19.1921 21.4623 19.9981Z",
    fill: "#00B9A7"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1425_8454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRise40);
export default __webpack_public_path__ + "static/media/rise_40.1576556e821c4177ddba4af4668e103a.svg";
export { ForwardRef as ReactComponent };